/* eslint-disable react/prop-types */
/* eslint-disable react/button-has-type */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Typography, Grid } from '@mui/material';
import { ReactComponent as Clock } from 'assets/icons/clock.svg';
import CountdownTimer from 'component/CountDownTimer/CountdownTimer';
import settingIcon from 'assets/svg/settingIcon.svg';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

import LinearProgress, {
  linearProgressClasses,
} from '@mui/material/LinearProgress';
import {
  displayFlexColumn,
  fontsize15,
  fontsize16,
  fontsize20,
  fontsize24,
  fontsize32,
  poppins300,
  poppins400,
  poppins500,
  poppins600,
} from 'theme/common.style';
import { liveDTag } from 'component/LiveOfferStatus/LiveOfferStatus.style';
import { counterCont } from 'component/LiveOfferStatus/CounterTimer.style';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import {
  counterAlignColumProp,
  counterSubProp,
  stageCont,
} from '../BuyerInterestedCard/BuyerInterested.style.js';
import { displayFlex } from 'component/ActivityContainer/ActivityContainer.style';
import QuickSwitchTimer from './QuickSwitchTimer';

function QuickSwitchPropertyTimer(props) {
  // eslint-disable-next-line react/prop-types
  const {
    isUnPublished,
    data,
    stage,
    propertyId,
    showSettingIcon,
    propertyData,
    cardapi,
    properties,
  } = props;
  // const [isRunning, setIsRunning] = React.useState(
  //   properties?.property?.status !== "Published"
  // );
  const [pause, SetPause] = useState();
  const data1 = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(data1);
  const dataType = userDetail?.userType;
  const THREE_DAYS_IN_MS = data;
  const NOW_IN_MS = new Date().getTime();
  const [dateTimeAfterThreeDays, setdateTimeAfterThreeDays] = useState(0);

  const history = useHistory();

  const onPropertyClick = () => {
    history.push({
      pathname: `/dashboard/property-profile/${propertyId}`,
    });
  };
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    marginTop: '10px',
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: '#E2E0E0',
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      background:
        'linear-gradient(180deg, #6D3BD6 0%, #6F5BDF 25.21%, #74A8F3 85.1%, #74B2F6 92.92%, #75BBF8 100%)',
      transform: 'rotate(-90deg)',
    },
  }));
  useEffect(() => {
    if (propertyData?.stage !== 0 && propertyData?.timerStatus === 'Start') {
      const currentTime = moment().valueOf();
      const dateWithStartAtCal = moment(propertyData?.startedAt).format();
      const duration = moment.duration(
        propertyData?.timerDuration,
        'milliseconds'
      );
      const runningDate = moment(dateWithStartAtCal).add(duration).toDate();
      setdateTimeAfterThreeDays(runningDate);
    } else if (
      propertyData?.stage !== 0 &&
      propertyData?.timerStatus === 'Pause'
    ) {
      SetPause(propertyData?.pausedTimerDuration);
    } else {
      const dateWithStartAtCal = moment(propertyData?.startedAt).format();
      const duration = moment.duration(
        propertyData?.timerDuration,
        'milliseconds'
      );
      const days = duration.days();
      const runningDate = moment(dateWithStartAtCal).toDate();
      setdateTimeAfterThreeDays(runningDate);
    }
  }, [propertyData]);

  const [isRunning, setIsRunning] = React.useState(true);
  // let remainingMillis =
  // propertyData?.timerDuration -
  //   (Date.now() - Date.parse(propertyData?.startedAt));
  // var time =
  //   (remainingMillis / propertyData?.timerDuration) * 100;

  var totalTimeMillis = moment(
    propertyData?.endedAt,
    'YYYY-MM-DD HH:mm:ss:SSS'
  ).diff(moment(propertyData?.startedAt, 'YYYY-MM-DD HH:mm:ss:SSS'));
  var remainingMillis = moment(moment().format('YYYY-MM-DD HH:mm:ss:SSS')).diff(
    moment(propertyData?.startedAt, 'YYYY-MM-DD HH:mm:ss:SSS')
  );
  var time = (remainingMillis / totalTimeMillis) * 100;

  let created = new Date(propertyData?.property?.propertyCreated).getTime();
  let start = Date.now();
  let end = new Date(propertyData?.startedAt).getTime();

  let elapsed = end - created - (end - start);

  var unpubtime = (elapsed / (end - created)) * 100;

  return (
    <Typography

    //   style={{ borderRadius: "5px", marginBottom: "10px" }}
    >
      {/* <Typography sx={counterSubProp}>
        <Typography sx={{ ...poppins500, fontSize:"16px" ,color:"rgba(102, 102, 102, 1)" }}>

          <Clock /> &nbsp; {dataType?.length ===1 ? (isUnPublished?("Countdown Timer"):"Campaign Timer"): ("CountDownTimer")}
        </Typography>
        <Typography sx={stageCont("#08A742")} style={{width:"76px" ,fontSize:"12px",fontWeight:600,fontFamily:"poppins",borderradius: "2px" ,height:"27.69px",textAlign:"center"}}>
          
        {isUnPublished?("Paused"):null}
            {stage=="ST1"?"STAGE 1" :null}
            {stage=="ST2"?"STAGE 2" :null}
          
          </Typography>
      </Typography> */}
      <Typography>
        {/* {isUnPublished ? (
          <Typography
            style={{ textAlign: "center" }}
            sx={{ ...poppins600, ...fontsize32 }}
          >
            N/A
          </Typography>



        ) : dateTimeAfterThreeDays > 0 ? (
          <CountdownTimer
            isRunning={isRunning}
            targetDate={dateTimeAfterThreeDays}
            propertyId={propertyId}
          />
         ) : (
          <Typography
            style={{ textAlign: "center" }}
            sx={{ ...poppins600, ...fontsize32 }}
          >
            N/A
          </Typography>
        )} */}

        <QuickSwitchTimer
          isRunning={isRunning}
          targetDate={dateTimeAfterThreeDays}
          propertyId={propertyId}
          isUnPublished={isUnPublished}
          cardapi={cardapi}
          paused={pause}
          pausestatus={propertyData?.timerStatus === 'Pause' ? true : false}
        />
      </Typography>
    </Typography>
  );
}

QuickSwitchPropertyTimer.defaultProps = {
  isUnPublished: false,
  showSettingIcon: true,
};

QuickSwitchPropertyTimer.propTypes = {
  isUnPublished: PropTypes.bool,
  showSettingIcon: PropTypes.bool,
};

export default QuickSwitchPropertyTimer;
